/**
 * @file 兼容多币的文案展示 - 左数右币，并且一组一组叠放版
 */
import { formatPrecision } from '@/utils/num';
import { appPath } from '@web3/base-utils';

import styles from './index.module.scss';
import {} from '@web3/base-utils';

interface Props {
  data: {
    url?: string;
    symbol: string;
    amount: string;
  }[];
}

export const MultiIconSpecial = (props: Props) => {
  const { data } = props;
  return (
    <>
      {data.map((item, index) => {
        return (
          <div className={styles.row} key={index}>
            <div
              className={styles.amount}
            >{`${formatPrecision(item.amount)}`}</div>
            <img
              className={styles.icon}
              src={item.url || `${appPath}/svg/home/icon-backup.svg`}
              alt=""
              key={index}
            />
            <div className={styles.symbol}>{item.symbol}</div>
          </div>
        );
      })}
    </>
  );
};
